import { NgClass } from "@angular/common";
import { Component, DoCheck, inject, Input, OnInit } from "@angular/core";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeCardModule, ForgeDividerModule } from "@tylertech/forge-angular";
import { Utilities } from "@tylertech/shared-module";
import { ICalendarDate, PropertyMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject, RepositoryFormData } from "../../interfaces";
import { MetadataPropertyService } from "../../services";
import { MetadataCalendarMonthComponent } from "./metadataCalendarMonth.component";

@Component({
    selector: "metadata-calendar",
    templateUrl: "./metadataCalendar.tmpl.html",
    imports: [
        ClassDirective,
        FlexDirective,
        LayoutAlignDirective,
        LayoutDirective,
        ForgeCardModule,
        ForgeDividerModule,
        MetadataCalendarMonthComponent,
        NgClass,
    ]
})

export class MetadataCalendarComponent implements OnInit, DoCheck
{
    private readonly $metadataPropertyService = inject(MetadataPropertyService);

    @Input() formRepository: RepositoryFormData;
    @Input() propertyMetadata: PropertyMetadata;
    @Input() model: ICalendarDate[];
    @Input() parent: AugmentedModelObject;
    @Input() viewOnly?: boolean;
    @Input() metadataModel: AugmentedModelObject;

    startDate: Date;
    drillStartDate: Date;
    title: string;

    private unboundModel: ICalendarDate[];

    private isInitialized: boolean;

    ngOnInit(): void
    {
        if (this.propertyMetadata)
        {
            const calMetadata = this.propertyMetadata.CalendarMetadata;
            this.startDate = calMetadata.StartDateProperty
                ? new Date(this.metadataModel[calMetadata.StartDateProperty])
                : new Date(calMetadata.StartDate);
            this.title = calMetadata.TitleProperty ? this.metadataModel[calMetadata.TitleProperty] : calMetadata.Title;
            this.isInitialized = true;
            this.unboundModel = Utilities.deepCopy(this.model);
        }
    }

    ngDoCheck(): void
    {
        if (!this.isInitialized)
        {
            return;
        }
        if (!Utilities.IsNullOrUndefined(this.model) && !Utilities.objectsEqual(this.unboundModel, this.model))
        {
            this._calendarKey = null;
            this._calendarMonths = null;
            const calMetadata = this.propertyMetadata.CalendarMetadata;
            this.startDate = calMetadata.StartDateProperty
                ? new Date(this.metadataModel[calMetadata.StartDateProperty])
                : new Date(calMetadata.StartDate);
            this.title = calMetadata.TitleProperty ? this.metadataModel[calMetadata.TitleProperty] : calMetadata.Title;
            this.unboundModel = Utilities.deepCopy(this.model);
        }
    }

    private _calendarMonths: Date[];

    get calendarMonths(): Date[]
    {
        if (Utilities.IsNullOrUndefined(this._calendarMonths))
        {
            const months: Date[] = [];
            if (Utilities.IsNullOrUndefined(this.startDate))
                this.startDate = new Date(new Date().getFullYear(), 0, 1);
            const startDateToUse = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1);
            for (let i = 0, l = 12; i < l; i++)
            {
                const month = new Date(startDateToUse);
                month.setMonth(startDateToUse.getMonth() + i);
                months.push(new Date(month));
            }
            this._calendarMonths = months;
        }
        return this._calendarMonths;
    }

    trackByFn(_index: number, item: ICalendarDate): string
    {
        return item.Id;
    }

    private _calendarKey: ICalendarDate[];

    get calendarKey(): ICalendarDate[]
    {
        if (Utilities.IsNullOrUndefined(this._calendarKey) && !Utilities.IsNullOrUndefined(this.model))
        {
            this._calendarKey = [];
            this.model.forEach(cd =>
            {
                if (this._calendarKey.filter(x => x.Color === cd.Color).length === 0)
                {
                    this._calendarKey.push(cd);
                }
            });
        }
        return this._calendarKey;
    }

    get Name(): string
    {
        return this.propertyMetadata.Name;
    }

    get hasTitle(): boolean
    {
        return !Utilities.IsNullOrUndefinedOrEmpty(this.title);
    }

    get isDisabled(): boolean
    {
        return (
            this.viewOnly ||
            this.$metadataPropertyService.isDisabled(
                this.propertyMetadata,
                this.metadataModel,
                this.parent,
            )
        );
    }

    isDrillIn: boolean = false;
    toggleDrillIn(date?: Date): void
    {
        this.drillStartDate = date;
        this.isDrillIn = !Utilities.IsNullOrUndefined(date);
    }
}
